export default function (instance) {
  return {
    faculty() {
      return instance.post("reg/faculty_dostup", {});
    },
    direction(payload) {
      return instance.post("reg/direction_dostup", { id_faculty: payload.id_faculty });
    },
    speciality(payload) {
      return instance.post("reg/speciality_dostup", {
        id_direction: payload.id_direction,
      });
    },
    f_o(payload) {
      return instance.post("f_o", {
        id_spes: payload.id_spes,
        id_type_o: payload.id_type_o,
      });
    },
    type_o(payload) {
      return instance.post("type_o", { id_spes: payload.id_spes });
    },
    list_info() {
      return instance.post("list_info", {});
    },
  };
}
